<script>
import Layout from "../../../../../layouts/main";
import PageHeader from "@/components/page-header";
// import Add from '../add.vue';
// import Transfer from './transfer.vue';
import axios from "axios";
import { InboundOrderPath } from "@/path.js";
import Swal from "sweetalert2";
import Show_batches from "../show_batches.vue";

export default {
  components: {
    Layout,
    PageHeader,
    // Add,
    // Transfer,
    Show_batches,
  },
  data() {
    return {
      title: "Gravy Transfer",
      items: [
        {
          text: "List",
        },
        {
          text: "Batches",
          active: true,
        },
      ],
      key: 1,
      filter: [],
      fields: [
        "production_date",
        "warehouse",
        "location",
        "gravies",
        "status",
        "actions",
      ],
      batches: [],
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      search: "",
      currentPage: 1,
      selectedOrder: null,
      status: "pending",
      cdn: process.env.VUE_APP_AWS_CDN,
      selectedProductionData: null,
      settingStatus: false,
      selectedOrderType: "production",
      typeOfItem: "gravies",
    };
  },
  mounted() {
    this.getOrders();
  },
  watch: {
    status() {
      this.getOrders();
    },
    currentPage() {
      this.getOrders();
    },
  },
  methods: {
    reload() {
      this.getOrders();
      this.selectedOrder = null;
    },
    addOrder() {
      this.selectedOrder = null;
      this.$bvModal.show("add");
      this.key += 1;
    },
    addTransferBatch() {
      // this.$bvModal.show('add-transfer');
      // this.key +=1 ;
      location.href = "/transfer_request";
    },
    async generateInvoice(v) {
      try {
        let res = await axios.get(
          this.baseUrl + InboundOrderPath.INBOUND_ORDER_INVOICE,
          {
            params: {
              date: v.production_date,
              type: v.order_type,
              is_gravy: true,
              warehouse_id: v.warehouse_id,
              location_id: v.location_id,
              from_warehouse_id: v.from_warehouse_id,
              from_location_id: v.from_location_id,
              status: v.status,
            },
          }
        );
        if (res.data.status) {
          this.downloadInvoiceFile(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    getGravies(item, type) {
      this.selectedProductionData = item;
      this.settingStatus = false;
      this.typeOfItem = type;
      this.$bvModal.show("show_batches");
    },
    downloadInvoiceFile(file) {
      const link = document.createElement("a");
      link.href = this.cdn + "/" + file;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async getOrders() {
      try {
        let res = await axios.get(this.baseUrl + InboundOrderPath.GET_ORDERS, {
          params: {
            page: this.currentPage,
            search: this.search,
            status: this.status,
            type: "gravy",
            transfer: true,
          },
        });
        if (res.data.status) {
          this.batches = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "pending") return "table-light";
      if (item.status == "completed") return "table-success";
      if (item.status == "progress") return "table-warning";
    },
    onRowSelected(v) {
      this.selectedOrder = v;
      if (v.order_type == "transfer") {
        this.$bvModal.show("add-transfer");
      } else {
        this.$bvModal.show("add");
      }
    },
    async deleteData(order) {
      try {
        console.log(order);
        let res = await axios.post(
          this.baseUrl + InboundOrderPath.DELETE_ORDER,
          {
            date: order.production_date,
            type: order.order_type,
          }
        );
        if (res.data.status) {
          Swal.fire("Success", "", "success");
          this.getOrders();
        }
      } catch (error) {
        console.log(error);
        Swal.fire(error.message, "", "error");
      }
    },
    async setStatus(v) {
      try {
        // if(v.status == 'completed'){
        //     Swal.fire('Sorry Cannot be edited once it is completed',"",'error');
        //     return;
        // }
        let inputValue = 0;
        let res;
        if (v.status == "pending") {
          const { value: qty_final } = await Swal.fire({
            title: "Enter Qty Received / Produced of (QTY-PO - " + v.qty + " )",
            input: "text",
            inputLabel: "Qty Received / Produced",
            inputValue,
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return "Cannot be empty";
              }
              if (value > v.qty) {
                return "Qty Needs to be same of less than Qty PO";
              }
            },
          });
          res = await axios.post(this.baseUrl + InboundOrderPath.UpdateStatus, {
            order_data: v,
            status:
              v.status == "pending"
                ? "completed"
                : v.status == "in_progress"
                ? "completed"
                : "completed",
            qty_final: qty_final,
          });
        } else {
          res = await axios.post(this.baseUrl + InboundOrderPath.UpdateStatus, {
            order_data: v,
            status: "pending",
          });
        }
        if (res.data.status) {
          Swal.fire("Updated Successfully", "", "success");
          this.getOrders();
        }
      } catch (error) {
        console.log(error);
      }
    },
    setBatchStatuses(v) {
      this.selectedProductionData = v;
      this.settingStatus = v.status == "pending" ? true : false;
      this.$bvModal.show("show_batches");
    },
    reloadData() {
      this.selectedProductionData = null;
      this.settingStatus = false;
      this.$bvModal.hide("show_batches");
      this.getOrders();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-header>
        <!-- <b-button variant="secondary" @click="addOrder"> + Add New Batch</b-button> -->
        <router-link
          to="gravy_transfer_request"
          class="ml-4 btn btn-primary"
          v-if="
            $store.state.authfack.user.permissions
              .map((p) => p.name)
              .includes('TransferBatch') ||
            $store.state.authfack.user.roles.filter(
              (f) => f.name == 'SuperAdmin'
            ).length > 0
          "
          >+ Add Transfer Batch</router-link
        >
      </b-card-header>
      <b-card-body>
        <b-modal
          size="xl"
          id="show_batches"
          :hide-footer="settingStatus == true"
        >
          <Show_batches
            @reload="reloadData"
            :type="typeOfItem"
            :settingStatus="settingStatus"
            :selectedProduction="selectedProductionData"
          ></Show_batches>
        </b-modal>
        <!-- <b-modal size="xl" id="add" hide-footer>
                    <Add @done="reload" :key="key" :selectedOrder="selectedOrder"></Add>
                </b-modal> -->
        <!-- <b-modal size="xl" id="add-transfer" hide-footer title="Add Transfer">
                    <Transfer @done="reloadData" :key="key" :selectedOrder="selectedOrder"></Transfer>
                </b-modal> -->
        <b-tabs>
          <b-tab title="All" @click="() => (status = '')"></b-tab>
          <b-tab
            title="Pending"
            @click="() => (status = 'pending')"
            active
          ></b-tab>
          <!-- <b-tab title="Progress" @click="(() => status = 'in_progress')"></b-tab> -->
          <b-tab
            title="Completed"
            @click="() => (status = 'completed')"
          ></b-tab>
        </b-tabs>
        <div class="table-responsive">
          <b-table
            :key="batches.key"
            :items="batches.data"
            :fields="fields"
            responsive="sm"
            :filter="filter"
            :current-page="currentPage"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:cell(warehouse)="row">
              {{ row.item.warehouse }}
            </template>
            <template v-slot:cell(location)="row">
              {{ row.item.location }}
            </template>
            <template v-slot:cell(gravies)="row">
              {{ row.item.gravies }}
              <b-button
                @click="getGravies(row.item, 'gravies')"
                variant="primary"
                size="sm"
                ><i class="fa fa-list"></i
              ></b-button>
            </template>
            <template v-slot:cell(packagings)="row">
              {{ row.item.packagings }}
              <b-button
                @click="getGravies(row.item, 'packagings')"
                variant="primary"
                size="sm"
                ><i class="fa fa-list"></i
              ></b-button>
            </template>
            <template v-slot:cell(status)="row">
              <b-button
                @click="setBatchStatuses(row.item, row.item.status)"
                :variant="
                  row.item.status == 'pending'
                    ? 'secondary'
                    : row.item.status == 'in_progress'
                    ? 'warning'
                    : 'success'
                "
                >{{
                  row.item.status == "pending"
                    ? "Move to Completed"
                    : row.item.status == "completed"
                    ? "Completed"
                    : "Move to Completed"
                }}</b-button
              >
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
                class="mr-4"
                size="sm"
                v-if="
                  (row.item.status == 'pending' ||
                    row.item.status == 'in_progress' ||
                    row.item.status == 'completed') &&
                  row.item.order_type == 'transfer'
                "
                @click="generateInvoice(row.item)"
                variant="success"
                v-b-tooltip:hover
                :title="
                  row.item.invoice_url != ''
                    ? 'Regenerate Invoice'
                    : 'Generate Invoice'
                "
              >
                <template>
                  <i class="fa fa-recycle"></i>
                </template>
              </b-button>
              <b-button
                size="sm"
                v-if="
                  (row.item.status == 'pending' ||
                    row.item.status == 'in_progress' ||
                    row.item.status == 'completed') &&
                  row.item.order_type == 'transfer' &&
                  row.item.invoice_url != '' &&
                  row.item.invoice_url != null
                "
                @click="downloadInvoiceFile(row.item.invoice_url)"
                v-b-tooltip:hover
                :title="row.item.invoice_url != '' ? 'Download Invoice' : ''"
              >
                <i class="fa fa-download"></i>
              </b-button>
              <b-button
                v-if="
                  row.item.status != 'completed' &&
                  row.item.order_type == 'production' &&
                  ($store.state.authfack.user.permissions
                    .map((p) => p.name)
                    .includes('WarehouseEdit') ||
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name == 'SuperAdmin'
                    ).length > 0)
                "
                variant="primary"
                size="sm"
                @click="onRowSelected(row.item)"
                class="mr-4"
                ><i class="fa fa-pen"></i
              ></b-button>
              <b-button
                v-if="
                  row.item.status != 'completed' &&
                  ($store.state.authfack.user.permissions
                    .map((p) => p.name)
                    .includes('WarehouseEdit') ||
                    $store.state.authfack.user.roles.filter(
                      (f) => f.name == 'SuperAdmin'
                    ).length > 0)
                "
                variant="danger"
                size="sm"
                @click="deleteData(row.item)"
                ><i class="fa fa-trash"></i
              ></b-button>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  :key="batches.key"
                  v-model="currentPage"
                  :total-rows="batches.total"
                  :per-page="batches.per_page"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </Layout>
</template>

<style></style>
